import type { ConfigService } from '@thinkalpha/ui-ioc/core/types/ConfigService';
import type { LaunchDarklyConfig } from '@thinkalpha/ui-types/types/config';
import type { OAuth2Config } from '@thinkalpha/ui-types/types/oauth';
import { OAuth2ConfigSchema } from '@thinkalpha/ui-types/types/schemas/OAuthConfigSchema';
import { injectable } from 'inversify';
import { appConfig } from 'src/lib/config/appConfig';

@injectable()
export class ConfigServiceImpl implements ConfigService {
    #appConfig = appConfig;

    get launchDarklyConfig(): LaunchDarklyConfig {
        return {
            clientSideId: this.#appConfig.launchDarklyClientSideId,
            environmentKey: this.#appConfig.launchDarklyEnvironmentKey,
        };
    }

    get oAuthConfig(): OAuth2Config {
        if (APP_ELECTRON) {
            return this.#appConfig.oAuth2Config;
        }

        const override = localStorage.getItem('configService.oAuthConfig.override');
        if (override) {
            try {
                const value = JSON.parse(override);
                const result = OAuth2ConfigSchema.safeParse(value);
                if (result.success) {
                    return result.data;
                } else {
                    // eslint-disable-next-line no-console -- direct console output
                    console.error('Invalid override value for oAuthConfig', result.error.issues);
                }
            } catch (e) {
                // eslint-disable-next-line no-console -- direct console output
                console.error('Error parsing override value for oAuthConfig', e);
            }
        }

        return this.#appConfig.oAuth2Config;
    }

    get environmentName() {
        return this.#appConfig.environmentName;
    }

    get commit() {
        return this.#appConfig.commit;
    }

    get documentTitle() {
        return this.#appConfig.documentTitle;
    }
}
